const navigation = (url) => {
  window.location.href = url;
};

export default navigation;
